import { render } from "./opp.vue?vue&type=template&id=cfc355f2&scoped=true"
const script = {}

import "./opp.vue?vue&type=style&index=0&id=cfc355f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc355f2"]])

export default __exports__